import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CustomButtonV2 from "../CustomButtonV2/CustomButtonV2.js";
import '../ModalSolucao/ModalSolucao.css';

export interface SimpleDialogProps {
    titulo: string;
    tituloBotao: string;
    texto: string;
    open: boolean;
    tituloInput: string;
    onClose: () => void;
    onClick: () => void;
    setTextoSolucao: (e) => void;
}

function ModalSolucao(props: SimpleDialogProps) {

    const { onClose, open, onClick } = props;

    const handleClose = () => {
        onClose();
    };

    const handleClick = () => {
        onClick();
    };

    return (
        <div>
            <Dialog
                open={open}
                onClose={handleClose}
            >
                <div className='div-modal-ontime'>
                    <DialogTitle id="alert-dialog-title">
                        {props.titulo}
                    </DialogTitle>
                    <DialogContent className="content-ontime">
                        <DialogContentText id="alert-dialog-description">
                            <div className="coluna-modalmotivo">
                                <div>
                                    <p className="input-label-emb">{props.tituloInput}</p>
                                    <input
                                        type="text"
                                        className="input-emb"
                                        style={{ width: '500px' }}
                                        onChange={(e) => {
                                            props.setTextoSolucao(e.target.value);
                                        }} />
                                </div>
                            </div>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions className="action-ontime">
                        <CustomButtonV2
                            classCss="custom-button-cadastrar"
                            classText="button-texto-cadastrar"
                            titulo="Registrar"
                            cor="#0946B8"
                            onClick={handleClick}
                        />
                        <CustomButtonV2
                            classCss="custom-button-cancelar"
                            classText="button-texto-cancelar"
                            titulo="Cancelar"
                            cor="#0946B8"
                            onClick={handleClose}
                        />
                    </DialogActions>
                </div>
            </Dialog>
        </div>
    );
}

export default ModalSolucao;